import { NotifyHelper } from "../../../helpers/toast";
import { eChuDeActionsObj } from "../../action-types/category/IChuDeActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const chuDeActions = {
  ...generateActions(eChuDeActionsObj, "CHU_DE"),
  ...generateActionForKey(eChuDeActionsObj, "CHU_DE", "SAVE_SUCCESS", () => {
    NotifyHelper.Success("Đã cập nhật");
  }),
  ...generateActionForKey(
    eChuDeActionsObj,
    "CHU_DE",
    "SAVE_ERROR",
    (m: string) => {
      NotifyHelper.Error(m);
    }
  ),
  ...generateActionForKey(eChuDeActionsObj, "CHU_DE", "DELETE_SUCCESS", () => {
    NotifyHelper.Success("Đã xóa");
  }),
  ...generateActionForKey(
    eChuDeActionsObj,
    "CHU_DE",
    "DELETE_ERROR",
    (m: string) => {
      NotifyHelper.Error(m);
    }
  ),
  ...generateActionForKey(eChuDeActionsObj, "CHU_DE", "IMPORT_SUCCESS", () => {
    NotifyHelper.Success("Import thành công!");
  }),
  ...generateActionForKey(
    eChuDeActionsObj,
    "CHU_DE",
    "IMPORT_ERROR",
    (m: string) => {
      NotifyHelper.Error(m);
    }
  ),
};
